<template>
  <div class="" v-if="day.type == undefined">
    <span class="reservation-day-date">{{ dateConverter(day.start, '/').split('/').slice(-1)[0] }}</span>
    <reservation-day-price class="d-block" :day="day"/>
  </div>
</template>


<script>
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import ReservationDayPrice from "../ReservationDayPrice.vue";

export default {
  name: "ReservationDayMode",
  components: {ReservationDayPrice},
  props: {
    day: {}
  },
  methods: {
    dateConverter,
  }
}
</script>

<style scoped>
.reservation-day-date{
  font-size: 14px;
  font-weight: bold;
}
</style>